import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  BulkUpdateStatusInput,
  BulkUpdateStatusForm,
} from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { bulkUpdateLeadStatus } from '@user/store/lead'

export const BulkUpdateLeadStatus: React.FC = () => {
  const dispatch = useAppDispatch()

  const validateRows = React.useCallback(
    async (model: BulkUpdateStatusInput) => {
      const response = await dispatch(bulkUpdateLeadStatus({ model }))
      if (bulkUpdateLeadStatus.fulfilled.match(response))
        return response.payload.model
    },
    [dispatch],
  )

  const onSubmit = React.useCallback(
    async (model: BulkUpdateStatusInput) =>
      void (await dispatch(
        bulkUpdateLeadStatus({
          model,
          mode: 'commit',
        }),
      )),
    [dispatch],
  )

  return (
    <BulkUpdateStatusForm
      entityType={ENTITY_TYPES.Lead}
      validateRows={validateRows}
      onSubmit={onSubmit}
    />
  )
}
BulkUpdateLeadStatus.displayName = 'BulkUpdateLeadStatus'
